import React from 'react';
import { Icon, StatusChip } from '../../components/sp-primitives';
import {
  creditorPaymentIconTitle,
  creditorPaymentIconTone,
  fmtCity,
  fmtCreated,
  fmtLastPaymentAmount,
  fmtLastPaymentDate,
  ynSiengeFlag,
} from './creditor-helpers';

function statusChip(s) {
  if (s === 'ativo' || s === 'active') return <StatusChip kind="green">ativo</StatusChip>;
  if (s === 'inativo' || s === 'inactive') return <StatusChip kind="red">inativo</StatusChip>;
  return <StatusChip kind="neutral">{s || '—'}</StatusChip>;
}

export function CreditorListCard({
  q,
  setQ,
  status,
  setStatus,
  supplier,
  setSupplier,
  employee,
  setEmployee,
  loading,
  err,
  payload,
  page,
  setPage,
  onOpenBank,
  onOpenPayments,
  onOpenAddress,
  onOpenContact,
  onDelete,
  isAdmin,
}) {
  const rows = payload?.data || [];
  const lastPage = payload?.last_page || 1;
  const totalMatches =
    payload != null && payload.total != null && payload.total !== ''
      ? Number(payload.total)
      : !loading && payload != null && Array.isArray(payload.data)
        ? payload.data.length
        : null;

  return (
    <div className="sp-card sp-card-flush sp-card-creditors">
      <div className="sp-creditors-toolbar">
        <div className="sp-field-block sp-creditors-field-grow">
          <label className="sp-caps sp-label" htmlFor="sp-cred-q">Busca</label>
          <input
            id="sp-cred-q"
            className="sp-input"
            placeholder="Nome, CPF, CNPJ, Cidade ou ID Sienge"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </div>
        <div className="sp-field-block">
          <label className="sp-caps sp-label" htmlFor="sp-cred-st">Status</label>
          <select id="sp-cred-st" className="sp-input" value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="">Todos</option>
            <option value="ativo">Ativo</option>
            <option value="inativo">Inativo</option>
          </select>
        </div>
        <div className="sp-field-block">
          <label className="sp-caps sp-label" htmlFor="sp-cred-sup">Fornecedor</label>
          <select id="sp-cred-sup" className="sp-input" value={supplier} onChange={(e) => setSupplier(e.target.value)}>
            <option value="">Todos</option>
            <option value="S">Sim</option>
            <option value="N">Não</option>
          </select>
        </div>
        <div className="sp-field-block">
          <label className="sp-caps sp-label" htmlFor="sp-cred-emp">Funcionário</label>
          <select id="sp-cred-emp" className="sp-input" value={employee} onChange={(e) => setEmployee(e.target.value)}>
            <option value="">Todos</option>
            <option value="S">Sim</option>
            <option value="N">Não</option>
          </select>
        </div>
      </div>
      {!err && (
        <div className="sp-creditors-results-hint" aria-live="polite">
          {loading ? (
            <span className="sp-creditors-results-hint__muted">A atualizar resultados…</span>
          ) : totalMatches != null && !Number.isNaN(totalMatches) ? (
            totalMatches === 1 ? (
              <>
                Foi encontrado: <strong>1</strong> resultado para sua busca.
              </>
            ) : (
              <>
                Foram encontrados: <strong>{totalMatches}</strong> resultados para sua busca.
              </>
            )
          ) : null}
        </div>
      )}
      {err && <div className="sp-creditors-banner sp-creditors-banner--err">{err}</div>}
      {loading && !err && <div className="sp-creditors-banner">Carregando…</div>}
      {!loading && !err && rows.length === 0 && (
        <div className="sp-creditors-banner">Aguardando sincronização de credores automática.</div>
      )}
      <table className="sp-table">
        <thead>
          <tr>
            <th>Status</th>
            <th>Credor(a)</th>
            <th>Cidade</th>
            <th>Criado em</th>
            <th>CPF</th>
            <th>CNPJ</th>
            <th>Forn.</th>
            <th>Func.</th>
            <th>Data Últ. Pag.</th>
            <th className="sp-th-num">Valor Últ. Pag.</th>
            <th className="sp-th-icon">
              <span className="sp-visually-hidden">Ações do credor</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {!loading &&
            rows.map((r) => (
              <tr key={r.id}>
                <td data-label="Status">{statusChip(r.status)}</td>
                <td data-label="Credor(a)">
                  <div className="sp-user-name">{r.name}</div>
                  <div className="sp-mono sp-user-email">Sienge ID:{r.sienge_creditorId}</div>
                </td>
                <td data-label="Cidade">{fmtCity(r)}</td>
                <td data-label="Criado em" className="sp-td-date sp-mono">{fmtCreated(r.created_at)}</td>
                <td data-label="CPF" className="sp-mono">{r.cpf || '—'}</td>
                <td data-label="CNPJ" className="sp-mono">{r.cnpj || '—'}</td>
                <td data-label="Forn.">{ynSiengeFlag(r.supplier)}</td>
                <td data-label="Func.">{ynSiengeFlag(r.employee)}</td>
                <td data-label="Data Últ. Pag." className="sp-td-date sp-mono">{fmtLastPaymentDate(r.last_payment_at)}</td>
                <td data-label="Valor Últ. Pag." className="sp-num sp-td-num">{fmtLastPaymentAmount(r.last_payment_amount)}</td>
                <td data-label="Ações" className="sp-td-actions sp-td-actions--icon">
                  <div className="sp-creditor-action-icons">
                    <button
                      type="button"
                      className="sp-btn sp-btn-ghost sp-creditor-bank-icon"
                      onClick={() => onOpenBank(r)}
                      title="Dados bancários"
                      aria-label="Dados bancários"
                    >
                      <Icon name="bank" size={17} stroke={1.75} />
                    </button>
                    <button
                      type="button"
                      className={`sp-btn sp-btn-ghost sp-creditor-addr-icon${r.has_sienge_address_data ? ' sp-creditor-addr-icon--has' : ''}`}
                      onClick={() => onOpenAddress(r)}
                      title={
                        r.has_sienge_address_data
                          ? 'Endereço — dados gravados no Sienge Pay a partir da API Sienge.'
                          : 'Endereço — sem dados gravados no Sienge Pay (sincronize os credores).'
                      }
                      aria-label="Endereço sincronizado"
                    >
                      <Icon name="mapPin" size={17} stroke={1.75} />
                    </button>
                    <button
                      type="button"
                      className={`sp-btn sp-btn-ghost sp-creditor-phone-icon${r.has_sienge_contact_data ? ' sp-creditor-phone-icon--has' : ''}`}
                      onClick={() => onOpenContact(r)}
                      title={
                        r.has_sienge_contact_data
                          ? 'Telefones e contactos — dados gravados no Sienge Pay a partir da API Sienge.'
                          : 'Telefones e contactos — sem dados gravados no Sienge Pay (sincronize os credores).'
                      }
                      aria-label="Telefones e contactos"
                    >
                      <Icon name="phone" size={17} stroke={1.75} />
                    </button>
                    <button
                      type="button"
                      className={`sp-btn sp-btn-ghost sp-creditor-payment-icon sp-creditor-payment-icon--${creditorPaymentIconTone(r.last_payment_at)}`}
                      onClick={() => onOpenPayments(r)}
                      title={creditorPaymentIconTitle(r.last_payment_at)}
                      aria-label="Pagamentos submetidos"
                    >
                      <Icon name="money" size={17} stroke={1.75} />
                    </button>
                    {isAdmin && <button
                      type="button"
                      className="sp-btn sp-btn-ghost sp-creditor-delete-icon"
                      style={{
                        color: 'var(--sp-color-danger, #e53e3e)',
                        opacity: r.has_approved_payments ? 0.35 : 1,
                        cursor: r.has_approved_payments ? 'not-allowed' : 'pointer',
                      }}
                      onClick={() => onDelete(r)}
                      title={r.has_approved_payments ? 'Este credor possui pagamentos salvos no sistema' : 'Excluir credor'}
                      aria-label="Excluir credor"
                    >
                      <Icon name="trash" size={17} stroke={1.75} />
                    </button>}
                  </div>
                </td>
              </tr>
            ))}
          {!loading && !err && rows.length === 0 && (
            <tr>
              <td colSpan={11} className="sp-td-empty">
                Aguardando sincronização de credores automática.
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {lastPage > 1 && (
        <div className="sp-creditors-pager">
          <button type="button" className="sp-btn sp-btn-outline sp-btn-tiny" disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>
            Anterior
          </button>
          <span className="sp-mono">
            Página {page} de {lastPage}
          </span>
          <button type="button" className="sp-btn sp-btn-outline sp-btn-tiny" disabled={page >= lastPage} onClick={() => setPage((p) => p + 1)}>
            Próxima
          </button>
        </div>
      )}
    </div>
  );
}
